<template>
  <div v-bind:id="uniqueId">
    <div v-show="showLoading">
      <div id="loading-grid">
        <svg
          class="spinner"
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            class="path"
            fill="none"
            stroke-width="6"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="30"
          ></circle>
        </svg>
      </div>
    </div>
    <div :class="tableContainerClasses" v-show="!showLoading">
      <div class="con-tablex vs-table--content">
        <div class="vs-con-tbody vs-table--tbody">
          <table class="vs-table vs-table--tbody-table">
            <thead class="vs-table--thead">
              <tr>
                <th v-if="indexRowEnabled" class="text-center font-bold">#</th>
                <slot name="columns" :columns="columns">
                  <th v-for="(c, cIndex) in columns" v-bind:key="cIndex">
                    <div
                      class="vs-table-text font-bold"
                      style="font-size: 1rem"
                    >
                      {{ c.title }}
                    </div>
                  </th>
                </slot>
              </tr>
            </thead>
            <tbody class="list">
              <tr
                v-for="(i, iIndex) in rowItems"
                v-bind:key="iIndex"
                :class="i.__tableRowClass"
                class="heightmatch1"
              >
                <td v-if="indexRowEnabled" class="text-center">
                  {{
                    (pagination.pageNumber - 1) * pagination.pageSize +
                    iIndex +
                    1
                  }}
                </td>
                <slot :row="i" :index="iIndex" :pagination="pagination">
                  <td
                    v-for="(c, cIndex) in columns"
                    v-bind:key="cIndex"
                    v-html="renderCell(c, i)"
                  ></td>
                </slot>
              </tr>
              <tr
                v-if="isExistData && additionalData && $props.showSum"
                class="total-row"
              >
                <td style="font-size: 1rem">مجموع</td>

                <td v-for="(c, cIndex) in columns" v-bind:key="cIndex">
                  <div
                    v-if="additionalData.find((o) => o.key == c.name)"
                    class="vs-table-text"
                  >
                    {{
                      Number(
                        additionalData.find((o) => o.key == c.name).value
                      ).toLocaleString()
                    }}
                  </div>
                </td>
              </tr>
              <tr
                class="total-row"
                v-if="
                  isExistData &&
                  additionalData &&
                  additionalData.length > 1 &&
                  $props.showSumOfAll
                "
              >
                <td style="font-size: 1rem; width: 4%">مجموع کل</td>

                <td v-for="(c, cIndex) in columns" v-bind:key="cIndex">
                  <div
                    v-if="additionalData.find((o) => o.key == c.total)"
                    class="vs-table-text"
                  >
                    {{
                      Number(
                        additionalData.find((o) => o.key == c.total).value
                      ).toLocaleString()
                    }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          
          <div v-if="rowItems && rowItems.length == 0 && !errorOccurred" class="no-records">
            {{ $t("NoRecordsFound") }}
          </div>
          <div v-if="errorOccurred" class="errorOccurred">
            {{ $t("OperationalError") }}!
            <br />
            <!-- {{ $t("TryLater") }} -->
            لطفا با ادمین سیستم تماس بگیرید.
          </div>
        </div>
      </div>
    </div>

    <div
      class="p-2 hide-in-print"
      v-if="paging && !showLoading && !rowItemAfterRemove.length"
    >
      <div class="vx-row">
        <div class="vx-col w-full mt-5 flex">
          <pagination
            v-model="pagination"
            v-if="paging"
            @change="renderGrid()"
            class="flex-auto"
          />

          <vs-select
            v-model="pagination.pageSize"
            @change="onPageChange()"
            v-if="pagination.total > 10"
            class="mr-auto grid-pagination"
          >
            <vs-select-item
              class="w-full"
              :value="10"
              :text="10"
              v-if="pagination.total > 0"
            />
            <vs-select-item
              class="w-full"
              :value="20"
              :text="20"
              v-if="pagination.total > 10"
            />
            <vs-select-item
              class="w-full"
              :value="50"
              :text="50"
              v-if="pagination.total > 20"
            />
            <vs-select-item
              class="w-full"
              :value="100"
              :text="100"
              v-if="pagination.total > 50"
            />
            <vs-select-item
              class="w-full"
              :value="500"
              :text="500"
              v-if="pagination.total > 100"
            />
            <vs-select-item
              class="w-full"
              :value="1000"
              :text="1000"
              v-if="pagination.total > 500"
            />
            <vs-select-item
              class="w-full"
              :value="2000"
              :text="2000"
              v-if="pagination.total > 1000"
            />
          </vs-select>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#div-loading .con-vs-loading {
  position: unset !important;
  margin: 0 auto;
  display: initial;
}

#div-loading .con-vs-loading .vs-loading {
  margin: 0 auto;
  display: inline-flex;
  width: 100%;
}
</style>

<style scoped>
.total-row {
  background-color: #007470 !important;
  color: white;
}
</style>
<script>
import { ajax } from "@/plugins/ajax";
import utils from "@/assets/utils/index";
import pagination from "./pagination";

export default {
  name: "data-grid",
  components: { pagination },
  props: {
    showSum: {
      default: true,
    },
    showSumOfAll: {
      default: true,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    pageSizeManual: {
      default: -1,
    },
    filterrow: {
      type: Array,
      default: () => [],
    },
    dataForAddToGrid: {
      type: Object,
    },
    dataSource: {
      type: Object,
      default: () => ({
        type: "",
        url: "",
        method: "get",
        service: "",
        transform: null,
        data: null,
      }),
    },
    searchData: {
      type: Object,
      default: () => ({}),
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: true,
    },
    hover: {
      type: Boolean,
      default: true,
    },
    indexRowEnabled: {
      type: Boolean,
      default: true,
    },
    paging: {
      type: Boolean,
      default: true,
    },
    hasPagination: {
      type: Boolean,
      default: true,
    },
    isPossibleToEdit: {
      type: Boolean,
      default: false,
    },
    idRowForRemove: {
      default: "",
    },
    hasModel: {
      type: Boolean,

      default: false,
    },
    body: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    tableContainerClasses() {
      var classes = "datagrid vs-component vs-con-table vs-table-primary";
      if (this.striped === true) classes += " stripe";
      if (this.bordered === true) classes += " table-bordered";
      if (this.hover === true) classes += " table-hover";
      return classes;
    },
  },
  data() {
    var uniqueId = "dt_" + utils.randomString(8);
    return {
      manulaPageSizeForRemove: null,
      rowItemAfterRemove: [],
      isExistData: false,
      additionalData: [],
      uniqueId: uniqueId,
      rowItems: [],
      pagination: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
      },
      sortField: "",
      sortType: "",
      showLoading: false,
      backgroundLoading: "#fff",
      colorLoading: "primary",
      errorOccurred: false,
    };
  },
  mounted() {
    this.renderGrid();
  },
  methods: {
    renderGrid(pageNo, filter) {
      var self = this;
      if (pageNo && filter && this.hasPagination) {
        self.pagination.pageNumber = pageNo;
      }
      this.showLoading = true;
      this.getData()
        .then((result) => {

          self.rowItems = result;
          this.$emit("showResult", self.rowItems);

          self.blockingEnd();
        })
        .catch(() => {
          self.blockingEnd();
        });
    },
    renderCell(columnItem, rowItem) {
      return rowItem[columnItem.field];
    },
    getData() {
      var self = this;
      return new Promise((resolve, reject) => {
        if (this.dataSource) {
          var getDataFromResourcePromise =
            this.dataSource.type == "ajax"
              ? self.getDataFromRemoteService()
              : this.dataSource.type == "app"
              ? self.getDataFromAppService()
              : self.getDataFromLocalArray();
          getDataFromResourcePromise
            .then((result) => {
              if (
                this.dataSource.transform &&
                utils.isFunction(this.dataSource.transform)
              )
                result = this.dataSource.transform(result);
              resolve(result);
            })
            .catch((e) => {
              reject(e);
            });
        } else {
          reject();
          this.errorOccurred = true;
        }
      });
    },
    getDataFromRemoteService() {
      return new Promise((resolve, reject) => {
        ajax[this.dataSource.method](this.dataSource.url)
          .then((r) => {
            
            if (r && r.data) {
              resolve(r.data);
            } else {
              reject();
            }
          })
          .catch(() => {
            reject();
            this.errorOccurred = true;
          });
      });
    },
    getDataFromAppService() {
      if (this.dataSource.method === "post") {
        var self = this;

        if (this.pageSizeManual % 10 == 0) {
          self.pagination.pageSize = this.pageSizeManual;
        }
        if (this.manulaPageSizeForRemove) {
          self.pagination.pageSize = this.manulaPageSizeForRemove;
        }
        var params='';
        if (this.hasPagination) {
          params =
            "?Take=" +
            (this.paging ? String(self.pagination.pageSize) : "0") +
            "&Skip=" +
            (this.paging
              ? String(
                  (self.pagination.pageNumber - 1) * self.pagination.pageSize
                )
              : "0");
        }

        var header = { "X-Ignore-Modal": "true" };
        return new Promise((resolve, reject) => {
          ajax[self.dataSource.method](
            self.dataSource.service + params,
            self.body,
            { headers: header }
          )
            .then((r) => {
              if (r && r.data) {
                if (r.data.total) {
                  this.isExistData = true;
                }
                if (self.dataSource.service == "Shipping/api/PackagesQuery") {
                  r.data.data.forEach((element) => {
                    element.isEditable = false;
                  });
                }
                self.pagination.total = parseInt(r.data.total);
                this.additionalData = r.data.additionalData;
                resolve(r.data.data);
              } else {
                reject();
              }
            })
            .catch(() => {
              reject();
              this.errorOccurred = true;
            });
        });
      } else {
        var self = this;
        for (var property in this.searchData) {
          if (!this.searchData[property]) {
            delete this.searchData[property];
          }
        }
        if (this.pageSizeManual % 10 == 0) {
          self.pagination.pageSize = this.pageSizeManual;
        }
        self.searchData = this.searchData;
        if (this.manulaPageSizeForRemove) {
          self.pagination.pageSize = this.manulaPageSizeForRemove;
        }
        var params='';
        if(this.hasPagination){
          params =
          "?take=" +
          (this.paging ? String(self.pagination.pageSize) : "0") +
          "&skip=" +
          (this.paging
            ? String(
                (self.pagination.pageNumber - 1) * self.pagination.pageSize
              )
            : "0") +
          "&" +
          utils.toQueryString(self.searchData);
        }
        else{
          params ="?" + utils.toQueryString(self.searchData);

        }

        return new Promise((resolve, reject) => {
          ajax[self.dataSource.method || "get"](
            self.dataSource.service + params
          )
            .then((r) => {
              if (r && r.data) {
                if (r.data.total) {
                  this.isExistData = true;
                }
                if (self.dataSource.service == "Shipping/api/PackagesQuery") {
                  r.data.data.forEach((element) => {
                    element.isEditable = false;
                  });
                }
                self.pagination.total = parseInt(r.data.total);
                this.additionalData = r.data.additionalData;
                if(r.data.data){
                  resolve(r.data.data);

                }
                else{
                  resolve(r.data);

                }
              } else {
                reject();
              }
            })
            .catch(() => {
              reject();
              this.errorOccurred = true;
            });
        });
      }
    },
    getDataFromLocalArray() {
      return new Promise((resolve) => {
        resolve(this.dataSource.data);
      });
    },
    onPageChange() {
      this.renderGrid(1, true);
    },

    blockingEnd() {
      this.showLoading = false;
    },
    getPagingTextData() {
      if(this.hasPagination){
        return {
        from:
          this.rowItems && this.rowItems.length > 0
            ? (this.pagination.pageNumber - 1) * this.pagination.pageSize + 1
            : 0,
        to:
          (this.pagination.pageNumber - 1) * this.pagination.pageSize +
          (this.rowItems.length < this.pagination.pageSize
            ? this.rowItems.length
            : this.pagination.pageSize),
        total: this.pagination.total,
      };
      }

    },
    sortColumn(col, type) {
      if (col.sort && col.sort.length > 0) {
        this.sortField = col.sort;
        this.sortType = type;
        this.renderGrid();
      }
    },
    removeSingleRow(i) {
      this.rowItemAfterRemove = this.rowItems.filter(function (element) {
        return i != element.genericProductId;
      });
      this.rowItems = this.rowItemAfterRemove;
    },
    addSingleRow(i) {
      this.rowItems.push({
        genericProductId: i.id,
        genericProductName: i.label,
      });
    },
  },
  watch: {
    idRowForRemove() {
      this.removeSingleRow(this.idRowForRemove);
    },
    dataForAddToGrid() {
      this.addSingleRow(this.dataForAddToGrid);
    },
    isPossibleToEdit() {
      if (this.isPossibleToEdit) {
        this.manulaPageSizeForRemove = 1000;
        this.renderGrid();
      } else {
        this.$emit("submitGridAfterChange", this.rowItems);
      }
    },
  },
};
</script>
